enum LisioCSSProperties {
  FONT_SIZE = "font-size",
  LINE_HEIGHT = "line-height",
  WORD_SPACING = "word-spacing",
  LETTER_SPACING = "letter-spacing",
  OVERFLOW_WRAP = "overflow-wrap",
  WORD_BREAK = "word-break",
  HYPHENS = "hyphens",
  FONT_FAMILY = "font-family",
  FILTER = "filter",
  PADDING_RIGHT = "padding-right",
  PADDING_LEFT = "padding-left",
  PADDING_TOP = "padding-top",
  PADDING_BOTTOM = "padding-bottom",
  PADDING = "padding",
  BORDER = "border",
  DISPLAY = "display",
  BACKGROUND = "background",
  BACKGROUND_COLOR = "background-color",
  COLOR = "color",
  BOX_SHADOW = "box-shadow",
  _WEBKIT_TEXT_FILL_COLOR = "-webkit-text-fill-color",
  ZOOM = "zoom",
  BORDER_COLOR = "border-color",
  BACKGROUND_IMAGE = "background-image",
  TEXT_ALIGN = "text-align",
  TRANSITION_DURATION = "transition-duration",
  ANIMATION_DURATION = "animation-duration",
  ANIMATION = "animation",
  TRANSITION = "transition",
  POSITION = "position",
  TOP = "top",
  Z_INDEX = "z-index",
  CURSOR = "cursor",
  MIN_HEIGHT = "min-height",
  TRANSFORM = "transform",
  MARGIN_LEFT = "margin-left",
}

export default LisioCSSProperties;
